import { createEndpoint } from "../utils/helpers";
import { getPromotions, getReplenishmentRequests } from "./AllServices";

export const ENDPOINTS = {
  login: createEndpoint("sessions", ["users"]),

  getAllStores: (pageNo, size, name = "") =>
    createEndpoint("stores", [], { page_no: pageNo, page_size: size, name }),

  saveStore: createEndpoint("stores"),

  updateStore: (id = "") => createEndpoint("stores", [id]),

  updateUser: (id = "") => createEndpoint("users", [id]),

  getUser: (id = "") => createEndpoint("users", [id]),

  users: createEndpoint("users"),

  allusers: (pageNo = "", size = "", is_paginated = false) =>
    createEndpoint("users", [], {
      page_number: pageNo,
      page_size: size,
      is_paginated,
    }),

  getStoreDetails: (id) => createEndpoint("stores", [id]),

  getUserRequests: (
    user_id = "",
    status = "",
    pageNo,
    size,
    searchQuery = "",
    requestType = ""
  ) => {
    const queryParams = {
      page_number: pageNo,
      page_size: size,
      search_query: searchQuery,
      request_type: requestType,
    };
    if (status) {
      queryParams.request_status = status;
    }
    return createEndpoint("users", [user_id, "requests"], queryParams);
  },

  userApproveRequest: (user_id = "", request_id = "") =>
    createEndpoint("users", [user_id, "requests", request_id]),

  getRequestDetails: (user_id = "", request_id = "") =>
    createEndpoint("users", [user_id, "requests", request_id]),

  getImage: (image_id = "", user_id = "") =>
    createEndpoint("files", [image_id]),

  getSKUCategories: (user_id = "") =>
    createEndpoint("users", [user_id, "sku-categories"]),

  getskuMapping: (pageNo, size) =>
    createEndpoint("users", ["sku-gwp-mappings"], {
      page_no: pageNo,
      page_size: size,
    }),

  getInventory: (user_id = "", item_category = "") =>
    createEndpoint("users", [user_id, "inventory"], { item_category }),

  createskuMapping: createEndpoint("users", ["sku-gwp-mappings"]),

  skuMappingById: (mapping_id) =>
    createEndpoint("users", ["sku-gwp-mappings", mapping_id]),

  addPulloutLetterPersonnel: createEndpoint("users", ["pullout-personnel"]),

  addDiscounts: createEndpoint("users", ["item_discounts"]),

  getReconciliationInfo: createEndpoint("users", ["sales-reconciliation-info"]),

  postReconciliationInfo: createEndpoint("users", ["upload-watson-sales"]),

  getFileById: (fileId) => createEndpoint("files", [fileId]),

  adjustReconciliation: (reconciliationId, status) =>
    createEndpoint("users", ["reconciliation-adjustment", reconciliationId], {
      is_approved: status,
    }),

  getReconciliationHistory: createEndpoint("users", [
    "past-sales-reconciliations",
  ]),

  replenishmentEmails: createEndpoint("replenishment-emails"),

  storeMonthlyCovers: createEndpoint("store-monthly-covers"),

  inveontoryUploads: (status) =>
    createEndpoint("initial-inventory", [], { status: status }),

  lastProcessedInveontoryUpload: () =>
    createEndpoint("initial-inventory", ["last-processed"], {}),

  pastInveontoryUploads: () => createEndpoint("initial-inventory", [], {}),

  retryBulkUpload: (id = "") => createEndpoint("initial-inventory", [id]),

  addInitialInventory: createEndpoint("initial-inventory", []),

  getReplenishmentRequests: (pageNo, size) =>
    createEndpoint("auto-replenishment-requests", [], {
      page_number: pageNo,
      page_size: size,
    }),

  getReplenishmentRequestsWithStatus: (pageNo, size, approval_status) =>
    createEndpoint("auto-replenishment-requests", [], {
      page_number: pageNo,
      page_size: size,
      approval_status: approval_status,
    }),

  getReplenishmentRequestDetails: (request_id, pageNo, size) =>
    createEndpoint("auto-replenishment-requests", [request_id, "items"], {
      page_number: pageNo,
      page_size: size,
    }),

  updateReplenishmentRequestItemQuantity: () =>
    createEndpoint("auto-replenishment-request-items", [], {}),

  updateReplenishmentRequestStatus: (request_id) =>
    createEndpoint("approve-auto-replenishment-requests", [request_id]),

  getPromotions: () => createEndpoint("promotions", [], {}),

  updatePromotion: () => createEndpoint("promotions", []),
};
